export default __webpack_public_path__ + "static/media/pin.0a0fb1da.svg";